import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'maintenance',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description: 'Maintenance tracking. Not yet implemented.',
    display: {
      isMain: true,
      position: 6,
    },
    name: 'Maintenance',
    page: { alias: 'maintenance' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
